import { styled } from '@mui/material';

import { FreePlan } from './components/FreePlan';
import { StarterPlan } from './components/StarterPlan';
import { ProPlan } from './components/ProPlan';
import { EnterprisePlan } from './components/EnterprisePlan';

const StyledPlanOptions = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  alignItems: 'stretch',
}));

export const PlanOptions = () => {
  return (
    <StyledPlanOptions>
      <FreePlan />
      <StarterPlan />
      <ProPlan />
      <EnterprisePlan />
    </StyledPlanOptions>
  );
};
